import { render } from "./TableCustomers.vue?vue&type=template&id=5844afca"
import script from "./TableCustomers.vue?vue&type=script&lang=js"
export * from "./TableCustomers.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])